// extracted by mini-css-extract-plugin
module.exports = {"section":"TNC_section__FyN7q"};